import React from "react";
import {
  FaCartPlus,
  FaBriefcaseMedical,
  FaHeadset,
  FaUserTie,
  FaUtensils,
} from "react-icons/fa6";
import { PiPlugsConnectedFill } from "react-icons/pi";
import { CiImport } from "react-icons/ci";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { GrValidate } from "react-icons/gr";
import NutradSPIcon from "../../assets/img/nt logo smart pipe.png";
import Footer from "../Footer/Footer";

const Validations = () => {
  const servicesData = [
    {
      icon: <GrValidate size={50} className="text-primary mb-4" />,
      title: "GS1 Validation",
      link: "/import",
      status: "Enabled",
      description:
        "GS1 standards component to validate GTIN, UPC, EAN and GLN product information.",
    },
    {
      icon: <FaBriefcaseMedical size={50} className="text-primary mb-4" />,
      title: "FDA Validation",
      link: "/products",
      status: "Enabled",
      description:
        "FDA Medical Devices (Global Unique Device Identification) validation component.",
    },
    {
      icon: <FaBriefcaseMedical size={50} className="text-primary mb-4" />,
      title: "OpenFDA",
      link: "/products",
      status: "Enabled",
      description:
        "FDA validation component focusing on Animal & Veterinary, Drugs, Devices and Food.",
    },
    {
      icon: <FaBriefcaseMedical size={50} className="text-primary mb-4" />,
      title: "CPSC Validation",
      link: "/products",
      status: "Enabled",
      description:
        "Consumer Product Safety Commission validation component for recalls and safety.",
    },
  ];

  return (
    <>
      <div className="py-5">
        <div className="container">
          <div className="mb-4">
            <h1 className="h3 fw-semibold mb-2">Available Validations</h1>
            <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
              Need another validation? Please contact validations@nutrad.io
            </p>
          </div>

          <div className="row g-4">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className={`col-lg-3 col-sm-6 wow fadeInUp`}
                data-wow-delay={`${0.1 + index * 0.2}s`}
              >
                <div className="service-item rounded pt-3">
                  <div className="p-4">
                    {service.icon}
                    <h2>{service.title}</h2>
                    <Badge bg="success">Enabled</Badge>
                    <br></br>
                    <p>{service.description}</p>

                    <br></br>
                    <Button variant="outline-primary" disabled="True">
                      Enabled
                    </Button>
                    {/* <Link
                      to={service.link}
                      // className="text-sm font-medium text-black hover:text-gray-100"
                    >
                      <Button variant="outline-primary" disabled="True">
                        Enabled
                      </Button>
                    </Link> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Validations;
